module.exports = __webpack_public_path__ + "static/media/loc3_img35.8fac6dea.jpg";